import { Routes } from '@angular/router';
import { PainelComponent } from './painel/painel.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from "./dashboard/dashboard.component";
import { UsuariosComponent } from "./usuarios/usuarios.component";
import { UsuariosFormComponent } from "./usuarios/usuarios-form.component";
import { LoginGuard } from "./login/login-guard.service";
import { UsuariosCargosComponent } from "./usuarios-cargos/usuarios-cargos.component";
import { UsuariosCargosFormComponent } from "./usuarios-cargos/usuarios-cargos-form.component";
import { MoedasComponent } from "./moedas/moedas.component";
import { MoedasFormComponent } from "./moedas/moedas-form.component";
import { MercadoriasComponent } from "./mercadorias/mercadorias.component";
import { MercadoriasFormComponent } from "./mercadorias/mercadorias-form.component";
import { MercadoInternoMercadoriasComponent } from "./mercado-interno-mercadorias/mercado-interno-mercadorias.component";
import { MercadoInternoMercadoriasFormComponent } from "./mercado-interno-mercadorias/mercado-interno-mercadorias-form.component";
import { MercadoInternoVariedadesComponent } from "./mercado-interno-mercadorias/mercado-interno-variedades.component";
import { MercadoInternoVariedadesFormComponent } from "./mercado-interno-mercadorias/mercado-interno-variedades-form.component";
import { MercadoInternoDefeitosComponent } from "./mercado-interno-mercadorias/mercado-interno-defeitos.component";
import { MercadoInternoDefeitosFormComponent } from "./mercado-interno-mercadorias/mercado-interno-defeitos-form.component";
import { MercadoInternoClassificacaoComponent } from "./mercado-interno-mercadorias/mercado-interno-classificacao.component";
import { MercadoInternoClassificacaoFormComponent } from "./mercado-interno-mercadorias/mercado-interno-classificacao-form.component";
import { AssinantesComponent } from "./assinantes/assinantes.component";
import { AssinantesFormComponent } from "./assinantes/assinantes-form.component";
import { LaboratoriosComponent } from "./laboratorios/laboratorios.component";
import { LaboratoriosFormComponent } from "./laboratorios/laboratorios-form.component";
import { ExamesNaviosComponent } from "./exames/navios/exames-navios.component";
import { ExamesNaviosFormComponent } from "./exames/navios/exames-navios-form.component";
import { ExamesCargosComponent } from "./exames/cargos/exames-cargos.component";
import { ExamesCargosFormComponent } from "./exames/cargos/exames-cargos-form.component";
import { ExamesDispositivosComponent } from "./exames/dispositivos/exames-dispositivos.component";
import { ExamesDispositivosFormComponent } from "./exames/dispositivos/exames-dispositivos-form.component";
import { ExamesTesteSoproComponent } from "./exames/teste-sopro/exames-teste-sopro.component";
import { ExamesTesteSoproFormComponent } from "./exames/teste-sopro/exames-teste-sopro-form.component";
import { PdfExamesTesteSoproComponent } from "./exames/teste-sopro/pdf-exames-teste-sopro.component";
import { PdfAvisoTesteEtilometroComponent } from "./exames/teste-sopro/pdf-aviso-teste-etilometro.component";
import { MeusTestesSoproComponent } from "./area-cliente/meus-testes-sopro/meus-testes-sopro.component";
import { PdfMeusTestesSoproComponent } from "./area-cliente/meus-testes-sopro/pdf-meus-testes-sopro.component";
import { ConfiguracoesComponent } from "./configuracoes/configuracoes.component";
import { ContainersComponent } from "./containers/containers.component";
import { ContainersFormComponent } from "./containers/containers-form.component";
import { PaisesComponent } from "./paises/paises.component";
import { PaisesFormComponent } from "./paises/paises-form.component";
import { MercadoriasDefeitosComponent } from "./mercadorias-defeitos/mercadorias-defeitos.component";
import { MercadoriasDefeitosFormComponent } from "./mercadorias-defeitos/mercadorias-defeitos-form.component";
import { MercadoriasVariedadesComponent } from "./mercadorias-variedades/mercadorias-variedades.component";
import { MercadoriasVariedadesFormComponent } from "./mercadorias-variedades/mercadorias-variedades-form.component";
import { ClientesComponent } from "./clientes/clientes.component";
import { ClientesFormComponent } from "./clientes/clientes-form.component";
import { MercadoriasEmbalagensComponent } from "./mercadorias-embalagens/mercadorias-embalagens.component";
import { MercadoriasEmbalagensFormComponent } from "./mercadorias-embalagens/mercadorias-embalagens-form.component";
import { MercadoriasCategoriasComponent } from "./mercadorias-categorias/mercadorias-categorias.component";
import { MercadoriasCategoriasFormComponent } from "./mercadorias-categorias/mercadorias-categorias-form.component";
import { MercadoriasColoracaoComponent } from "./mercadorias-coloracao/mercadorias-coloracao.component";
import { MercadoriasColoracaoFormComponent } from "./mercadorias-coloracao/mercadorias-coloracao-form.component";
import { MercadoriasClassificacaoComponent } from "./mercadorias-classificacao/mercadorias-classificacao.component";
import { MercadoriasClassificacaoFormComponent } from "./mercadorias-classificacao/mercadorias-classificacao-form.component";
import { UnidadesComponent } from "./unidades/unidades.component";
import { UnidadesFormComponent } from "./unidades/unidades-form.component";
import { TransportesComponent } from "app/transportes/transportes.component";
import { TransportesFormComponent } from "./transportes/transportes-form.component";
import { LocaisComponent } from "./locais/locais.component";
import { LocaisFormComponent } from "./locais/locais-form.component";
import { TransportesViagensComponent } from "./transportes-viagens/transportes-viagens.component";
import { TransportesViagensFormComponent } from "./transportes-viagens/transportes-viagens-form.component";
import { ObservacoesFichasComponent } from "./observacoes-fichas/observacoes-fichas.component";
import { ObservacoesFichasFormComponent } from "./observacoes-fichas/observacoes-fichas-form.component";
import { ConclusoesFichasComponent } from "./conclusoes-fichas/conclusoes-fichas.component";
import { ConclusoesFichasFormComponent } from "app/conclusoes-fichas/conclusoes-fichas-form.component";
import { FichasComponent } from "./fichas/fichas.component";
import { FichasObservacoesFixasComponent } from "./fichas-observacoes-fixas/observacoes-fixas.component";
import { FichasObservacoesFixasFormComponent } from "./fichas-observacoes-fixas/observacoes-fixas-form.component";
import { FichasFormComponent } from "./fichas/fichas-form.component";
import { VisualizarFichaComponent } from "./fichas/visualizar-ficha.component";
import { FollowUpComponent } from "./follow-up/follow-up.component";
import { FollowUpFormComponent } from "./follow-up/follow-up-form.component";
import { VeiculosComponent } from "./veiculos/veiculos.component";
import { VeiculosFormComponent } from "./veiculos/veiculos-form.component";
import { EquipamentosComponent } from "./equipamentos/equipamentos.component";
import { EquipamentosFormComponent } from "./equipamentos/equipamentos-form.component";
import { VeiculosCorridaComponent } from "./veiculos-corrida/veiculos-corrida.component";
import { VeiculosCorridaFormComponent } from "./veiculos-corrida/veiculos-corrida-form.component";
import { VeiculosArquivosComponent } from "./veiculos/veiculos-arquivos.component";
import { ClientesUsuariosComponent } from "app/clientes-usuarios/clientes-usuarios.component";
import { ClientesUsuariosFormComponent } from "./clientes-usuarios/clientes-usuarios-form.component";
import { MinhasFichasComponent } from "./area-cliente/minhas-fichas/minhas-fichas.component";
import { FichaClienteComponent } from "./area-cliente/minhas-fichas/ficha-cliente.component";
import { PdfFichaClienteComponent } from "./area-cliente/minhas-fichas/pdf-ficha-cliente.component";
import { PdfFichaComponent } from "./fichas/pdf-ficha.component";
import { FinanceiroComponent } from "./financeiro/financeiro.component";
import { ControleFinanceiroComponent } from "./financeiro/controle-financeiro.component";
import { RelatorioCompletoComponent } from "./financeiro/relatorio-completo.component";
import { DashboardFinanceiroComponent } from "./financeiro/dashboard-financeiro.component";
import { FaturasComponent } from "./faturas/faturas.component";
import { FinanceiroClientesComponent } from "./financeiro/financeiro-clientes.component";
import { FinanceiroPreliminaresClienteComponent } from "./financeiro/financeiro-preliminares-cliente.component";
import { FinanceiroLaudosPdfClienteComponent } from "./financeiro/financeiro-laudos-pdf-cliente.component";
import { FinanceiroLaudosCdClienteComponent } from "./financeiro/financeiro-laudos-cd-cliente.component";
import { UnidadesMedidasComponent } from "./unidades-medidas/unidades-medidas.component";
import { UnidadesMedidasFormComponent } from "./unidades-medidas/unidades-medidas-form.component";
import { VisualizarFaturaComponent } from "./faturas/visualizar-fatura.component";
import { BancosComponent } from "./bancos/bancos.component";
import { BancosFormComponent } from "./bancos/bancos-form.component";
import { PdfFaturaComponent } from "./faturas/pdf-fatura.component";
import { ProtestosFichasFormComponent } from "./protestos-fichas/protestos-fichas-form.component";
import { ProtestosFichasComponent } from "./protestos-fichas/protestos-fichas.component";
import { LaudosPdfComponent } from "./laudos-pdf/laudos-pdf.component";
import { LaudosPdfFormComponent } from "./laudos-pdf/laudos-pdf-form.component";
import { LaudosPdfFinanceiroComponent } from "./laudos-pdf/laudos-pdf-financeiro.component";
import { LaudosCDFinanceiroComponent } from "./laudos-cd/laudos-cd-financeiro.component";

import { MeusLaudosPdfComponent } from "./area-cliente/meus-laudos-pdf/meus-laudos-pdf.component";
import { MeusLaudosPdfFormComponent } from "./area-cliente/meus-laudos-pdf/meus-laudos-pdf-form.component";
import { MeusLaudosCDComponent } from "./area-cliente/meus-laudos-cd/meus-laudos-cd.component";
import { MeusLaudosCDFormComponent } from "./area-cliente/meus-laudos-cd/meus-laudos-cd-form.component";
import { FaturasFormComponent } from "./faturas/faturas-form.component";
import { TransportadorasComponent } from "./transportadoras/transportadoras.component";
import { TransportadorasFormComponent } from "./transportadoras/transportadoras-form.component";
import { ColoracaoComponent } from "./laudos-cd-coloracao/coloracao.component";
import { ColoracaoFormComponent } from "./laudos-cd-coloracao/coloracao-form.component";
import { LaudosCDComponent } from "./laudos-cd/laudos-cd.component";
import { TipoTransporteComponent } from "./tipo-transporte/tipo-transporte.component";
import { TipoTransporteFormComponent } from "./tipo-transporte/tipo-transporte-form.component";
import { TipoUnidadeComponent } from "./tipo-unidade/tipo-unidade.component";
import { TipoUnidadeFormComponent } from "./tipo-unidade/tipo-unidade-form.component";
import { LabelFotosLaudoscdComponent } from "./label-fotos-laudoscd/label-fotos-laudoscd.component";
import { LabelFotosLaudoscdFormComponent } from "./label-fotos-laudoscd/label-fotos-laudoscd-form.component";
import { LaudosCDFormComponent } from "./laudos-cd/laudos-cd-form.component";
import { StakeholdersComponent } from "./laudos-cd-stakeholders/stakeholders.component";
import { StakeholdersFormComponent } from "./laudos-cd-stakeholders/stakeholders-form.component";
import { ResponsaveisTecnicosComponent } from "./laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos.component";
import { ResponsaveisTecnicosFormComponent } from "./laudos-cd-responsaveis-tecnicos/responsaveis-tecnicos-form.component";
import { ObservacoesLaudosComponent } from "./laudos-cd-observacoes/observacoes-laudos.component";
import { ObservacoesLaudosFormComponent } from "./laudos-cd-observacoes/observacoes-laudos-form.component";
import { ObservacoesFixasComponent } from "./laudos-cd-observacoes-fixas/observacoes-fixas.component";
import { ObservacoesFixasFormComponent } from "./laudos-cd-observacoes-fixas/observacoes-fixas-form.component";
import { UsuariosCargosNomesComponent } from "./usuarios-cargos-nomes/usuarios-cargos-nomes.component";
import { UsuariosCargosNomesFormComponent } from "./usuarios-cargos-nomes/usuarios-cargos-nomes-form.component";
import { PdfLaudoCDComponent } from "./laudos-cd/pdf-laudo-cd.component";

import { FinanceiroLaudosTecnicosClienteComponent } from "./financeiro/financeiro-laudos-tecnicos-cliente.component";
import { FinanceiroCertificadosNacionaisClienteComponent } from "./financeiro/financeiro-certificados-nacionais-cliente.component";
import { LaudosTecnicosFinanceiroComponent } from "./laudos-tecnicos/laudos-tecnicos-financeiro.component";
import { MeusLaudosTecnicosComponent } from "./area-cliente/meus-laudos-tecnicos/meus-laudos-tecnicos.component";
import { MeusLaudosTecnicosFormComponent } from "./area-cliente/meus-laudos-tecnicos/meus-laudos-tecnicos-form.component";

import { LaudosTecnicosComponent } from "./laudos-tecnicos/laudos-tecnicos.component";
import { LabelFotosLaudosTecnicosComponent } from "./label-fotos-laudostecnicos/label-fotos-laudostecnicos.component";
import { LabelFotosLaudosTecnicosFormComponent } from "./label-fotos-laudostecnicos/label-fotos-laudostecnicos-form.component";
import { LaudosTecnicosFormComponent } from "./laudos-tecnicos/laudos-tecnicos-form.component";
import { StakeholdersTecnicosComponent } from "./laudos-tecnicos-stakeholders/stakeholders.component";
import { StakeholdersTecnicosFormComponent } from "./laudos-tecnicos-stakeholders/stakeholders-form.component";


import { PdfLaudoTecnicoComponent } from "./laudos-tecnicos/pdf-laudo-tecnico.component";

import { ExportadoresComponent } from "./exportadores/exportadores.component";
import { ExportadoresFormComponent } from "./exportadores/exportadores-form.component";
import { TerminaisComponent } from "./terminais/terminais.component";
import { TerminaisFormComponent } from "./terminais/terminais-form.component";
import { ArmadoresComponent } from "./armadores/armadores.component";
import { ArmadoresFormComponent } from "./armadores/armadores-form.component";
import { CertificadosNacionaisComponent } from './certificados-nacionais/certificados-nacionais.component';
import { CertificadosNacionaisFormComponent } from './certificados-nacionais/certificados-nacionais-form.component';
import { PdfCertificadoNacionalComponent } from './certificados-nacionais/pdf-certificado-nacional.component';
import { RelatorioCertificadosNacionaisComponent } from './certificados-nacionais/relatorio-certificados-nacionais.component';
import { RelatorioRmcvCertificadosNacionaisComponent } from './certificados-nacionais/relatorio-rmcv-certificados-nacionais.component';
import { TerminaisNacionaisComponent } from './terminais-nacionais/terminais-nacionais.component';
import { TerminaisNacionaisFormComponent } from './terminais-nacionais/terminais-nacionais-form.component';
import { ValidarComponent } from './validar/validar.component';


export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Login', breadcrumb: 'Login' }
  },
  {
    path: 'login-cliente',
    component: LoginComponent,
    data: { title: 'Login', breadcrumb: 'Login' }
  },
  {
    path: 'nao-autorizado',
    component: LoginComponent,
    data: { title: 'Não Autorizado', breadcrumb: 'Login' }
  },
  {
    path: 'nao-autorizado-cliente',
    component: LoginComponent,
    data: { title: 'Não Autorizado', breadcrumb: 'Login' }
  },
  {
    path: 'validar',
    component: ValidarComponent,
    data: { title: 'Validar DOC', breadcrumb: 'Validar DOC' }
  },
  {
    path: 'validar/:cod',
    component: ValidarComponent,
    data: { title: 'Validar DOC', breadcrumb: 'Validar DOC' }
  },
  {
    path: 'painel',
    component: PainelComponent,
    canActivate: [LoginGuard],
    data: { title: 'Painel', breadcrumb: 'Painel', icone: 'icon icon-home' },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'certificados-nacionais',
        canActivate: [LoginGuard],
        data: { title: 'Certificados Nacionais', breadcrumb: 'Certificados Nacionais', icone: 'icon-location4' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: CertificadosNacionaisComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-location4' },
          },
          {
            path: 'relatorio',
            component: RelatorioCertificadosNacionaisComponent,
            canActivate: [LoginGuard],
            data: { title: 'Relatório', breadcrumb: 'Relatório', icone: 'icon-location4' },
          },
          {
            path: 'relatorio-rmcv',
            component: RelatorioRmcvCertificadosNacionaisComponent,
            canActivate: [LoginGuard],
            data: { title: 'Relatório RMCV', breadcrumb: 'Relatório RMCV', icone: 'icon-location4' },
          },
          {
            path: 'em-processamento',
            pathMatch: 'full',
            component: CertificadosNacionaisComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem - Em Processamento', breadcrumb: 'Listagem - Em Processamento', icone: 'icon-location4' },
          },
          {
            path: 'emitidos',
            pathMatch: 'full',
            component: CertificadosNacionaisComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem - Emitidos', breadcrumb: 'Listagem - Emitidos', icone: 'icon-location4' },
          },
          {
            path: 'add',
            component: CertificadosNacionaisFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar Certificado Nacional', breadcrumb: 'Adicionar Certificado Nacional', icone: 'icon-location4' },
          },
          {
            path: ':id_certificado',
            canActivate: [LoginGuard],
            data: { title: 'Local', breadcrumb: 'Local', icone: 'icon-location4' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: CertificadosNacionaisFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Local', breadcrumb: 'Local', icone: 'icon-location4' },
              },
              {
                path: 'upd',
                component: CertificadosNacionaisFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-location4' }
              },
              {
                path: 'pdf',
                component: PdfCertificadoNacionalComponent,
                canActivate: [LoginGuard],
                data: { title: 'PDF', breadcrumb: 'PDF', icone: 'icon-location4' }
              }
            ]
          }
        ]
      },
      {
        path: 'terminais-nacionais',
        canActivate: [LoginGuard],
        data: { title: 'Terminais Nacionais', breadcrumb: 'Terminais Nacionais', icone: 'icon-location4' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: TerminaisNacionaisComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-location4' },
          },
          {
            path: 'add',
            component: TerminaisNacionaisFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-location4' }
          },
          {
            path: ':id_terminal',
            canActivate: [LoginGuard],
            data: { title: 'Local', breadcrumb: 'Local', icone: 'icon-location4' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: TerminaisNacionaisFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Local', breadcrumb: 'Local', icone: 'icon-location4' },
              },
              {
                path: 'upd',
                component: TerminaisNacionaisFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-location4' }
              }
            ]
          }
        ]
      },
      {
        path: 'mercado-interno-mercadorias',
        canActivate: [LoginGuard],
        data: { title: 'Mercadorias (Mercado Interno)', breadcrumb: 'Mercadorias', icone: 'fa fa-shopping-cart' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: MercadoInternoMercadoriasComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-shopping-cart' },
          },
          {
            path: 'add',
            component: MercadoInternoMercadoriasFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-shopping-cart' }
          },
          {
            path: 'defeitos',
            canActivate: [LoginGuard],
            data: { title: 'Defeitos', breadcrumb: 'Defeitos', icone: 'fa fa-shopping-cart' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoInternoDefeitosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-shopping-cart' },
              },
              {
                path: 'add',
                component: MercadoInternoDefeitosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-shopping-cart' }
              },
              {
                path: ':id_defeito',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: MercadoInternoDefeitosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                  },
                  {
                    path: 'upd',
                    component: MercadoInternoDefeitosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-shopping-cart' }
                  }
                ]
              }
            ]
          },
          {
            path: 'variedades',
            canActivate: [LoginGuard],
            data: { title: 'Variedades', breadcrumb: 'Variedades', icone: 'fa fa-shopping-cart' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoInternoVariedadesComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-shopping-cart' },
              },
              {
                path: 'add',
                component: MercadoInternoVariedadesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-shopping-cart' }
              },
              {
                path: ':id_variedade',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: MercadoInternoVariedadesFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                  },
                  {
                    path: 'upd',
                    component: MercadoInternoVariedadesFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-shopping-cart' }
                  }
                ]
              }
            ]
          },
          {
            path: 'classificacao',
            canActivate: [LoginGuard],
            data: { title: 'Classificação', breadcrumb: 'Classificação', icone: 'fa fa-shopping-cart' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoInternoClassificacaoComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-shopping-cart' },
              },
              {
                path: 'add',
                component: MercadoInternoClassificacaoFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-shopping-cart' }
              },
              {
                path: ':id_classificacao',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: MercadoInternoClassificacaoFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                  },
                  {
                    path: 'upd',
                    component: MercadoInternoClassificacaoFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-shopping-cart' }
                  }
                ]
              }
            ]
          },
          {
            path: ':id_mercadoria',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoInternoMercadoriasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
              },
              {
                path: 'upd',
                component: MercadoInternoMercadoriasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-shopping-cart' }
              }
            ]
          }
        ]
      },
      {
        path: 'assinantes',
        canActivate: [LoginGuard],
        data: { title: 'Assinantes', breadcrumb: 'Assinantes', icone: 'icon-users4' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: AssinantesComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-users4' },
          },
          {
            path: 'add',
            component: AssinantesFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-users4' }
          },
          {
            path: ':id_assinante',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-users4' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: AssinantesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-users4' },
              },
              {
                path: 'upd',
                component: AssinantesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-users4' }
              }
            ]
          }
        ]
      },
      {
        path: 'laboratorios',
        canActivate: [LoginGuard],
        data: { title: 'Laboratórios', breadcrumb: 'Laboratórios', icone: 'icon-office' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: LaboratoriosComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-office' },
          },
          {
            path: 'add',
            component: LaboratoriosFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-office' }
          },
          {
            path: ':id_laboratorio',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-office' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LaboratoriosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-office' },
              },
              {
                path: 'upd',
                component: LaboratoriosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-office' }
              }
            ]
          }
        ]
      },
      {
        path: 'exames',
        canActivate: [LoginGuard],
        data: { title: 'Exames', breadcrumb: 'Exames', icone: 'icon-file-list' },
        children: [
          {
            path: 'navios',
            canActivate: [LoginGuard],
            data: { title: 'Navios', breadcrumb: 'Navios', icone: 'icon-ship' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ExamesNaviosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-ship' },
              },
              {
                path: 'add',
                component: ExamesNaviosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-ship' }
              },
              {
                path: ':id_navio',
                canActivate: [LoginGuard],
                data: { title: 'Navio', breadcrumb: 'Navio', icone: 'icon-ship' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ExamesNaviosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-ship' },
                  },
                  {
                    path: 'upd',
                    component: ExamesNaviosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-ship' }
                  }
                ]
              }
            ]
          },
          {
            path: 'cargos',
            canActivate: [LoginGuard],
            data: { title: 'Cargos', breadcrumb: 'Cargos', icone: 'icon-briefcase' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ExamesCargosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-briefcase' },
              },
              {
                path: 'add',
                component: ExamesCargosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-briefcase' }
              },
              {
                path: ':id_cargo',
                canActivate: [LoginGuard],
                data: { title: 'Cargo', breadcrumb: 'Cargo', icone: 'icon-briefcase' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ExamesCargosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-briefcase' },
                  },
                  {
                    path: 'upd',
                    component: ExamesCargosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-briefcase' }
                  }
                ]
              }
            ]
          },
          {
            path: 'dispositivos',
            canActivate: [LoginGuard],
            data: { title: 'Dispositivos', breadcrumb: 'Dispositivos', icone: 'icon-cogs' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ExamesDispositivosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-cogs' },
              },
              {
                path: 'add',
                component: ExamesDispositivosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-cogs' }
              },
              {
                path: ':id_dispositivo',
                canActivate: [LoginGuard],
                data: { title: 'Dispositivo', breadcrumb: 'Dispositivo', icone: 'icon-cogs' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ExamesDispositivosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-cogs' },
                  },
                  {
                    path: 'upd',
                    component: ExamesDispositivosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-cogs' }
                  }
                ]
              }
            ]
          },
          {
            path: 'teste-sopro',
            canActivate: [LoginGuard],
            data: { title: 'Teste de Álcool', breadcrumb: 'Teste de Álcool', icone: 'icon-meter-fast' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ExamesTesteSoproComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-meter-fast' },
              },
              {
                path: 'add',
                component: ExamesTesteSoproFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-meter-fast' }
              },
              {
                path: ':id_teste',
                canActivate: [LoginGuard],
                data: { title: 'Teste de Álcool', breadcrumb: 'Teste de Álcool', icone: 'icon-meter-fast' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ExamesTesteSoproFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-meter-fast' },
                  },
                  {
                    path: 'upd',
                    component: ExamesTesteSoproFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-meter-fast' }
                  },
                  {
                    path: 'pdf',
                    component: PdfExamesTesteSoproComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar PDF', breadcrumb: 'Visualizar PDF', icone: 'icon-file-pdf' }
                  },
                  {
                    path: 'aviso-pdf',
                    component: PdfAvisoTesteEtilometroComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Aviso de Teste de Etilômetro', breadcrumb: 'Aviso de Teste de Etilômetro', icone: 'icon-file-pdf' }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'configuracoes',
        component: ConfiguracoesComponent,
        canActivate: [LoginGuard],
        data: { title: 'Configurações', breadcrumb: 'Configurações', icone: 'icon-cog' }
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [LoginGuard],
        data: { title: 'Dashboard', breadcrumb: 'Dashboard', icone: 'icon icon-home' }
      },
      {
        path: 'usuarios',
        canActivate: [LoginGuard],
        data: { title: 'Usuários', breadcrumb: 'Usuários', icone: 'icon icon-users4' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: UsuariosComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-users4' },
          },
          {
            path: 'add',
            component: UsuariosFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar Usuário', breadcrumb: 'Adicionar Usuário', icone: 'icon icon-users4' },
          },
          {
            path: 'cargos',
            canActivate: [LoginGuard],
            data: { title: 'Cargos', breadcrumb: 'Cargos', icone: 'icon icon-office' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: UsuariosCargosNomesComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-office' },
              },
              {
                path: 'add',
                component: UsuariosCargosNomesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon icon-office' }
              },
              {
                path: ':id',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-office' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: UsuariosCargosNomesFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-office' },
                  },
                  {
                    path: 'upd',
                    component: UsuariosCargosNomesFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-office' }
                  }
                ]
              }
            ]
          },
          {
            path: 'tipos-acesso',
            canActivate: [LoginGuard],
            data: { title: 'Cargos de Usuários', breadcrumb: 'Cargos de Usuários', icone: 'icon icon-office' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: UsuariosCargosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-coins' },
              },
              {
                path: 'add',
                component: UsuariosCargosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon icon-office' }
              },
              {
                path: ':id_cargo',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-office' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: UsuariosCargosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-coins' },
                  },
                  {
                    path: 'upd',
                    component: UsuariosCargosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar Cargo', breadcrumb: 'Editar Cargo', icone: 'icon icon-office' }
                  }
                ]
              }
            ]
          },
          {
            path: ':id_usuario',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar Usuário', breadcrumb: 'Visualizar Usuário', icone: 'icon icon-users4' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: UsuariosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-users4' },
              },
              {
                path: 'upd',
                component: UsuariosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-users4' }
              }
            ]
          }
        ]
      },
      {
        path: 'clientes',
        canActivate: [LoginGuard],
        data: { title: 'Clientes', breadcrumb: 'Clientes', icone: 'fa fa-university' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: ClientesComponent,
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
          },
          {
            path: 'usuarios',
            canActivate: [LoginGuard],
            data: { title: 'Usuários', breadcrumb: 'Usuários', icone: 'icon icon-users4' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ClientesUsuariosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-users4' },
              },
              {
                path: 'add',
                component: ClientesUsuariosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar Usuário', breadcrumb: 'Adicionar Usuário', icone: 'icon icon-users4' },
              },
              {
                path: ':id_usuario',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar Usuário', breadcrumb: 'Visualizar Usuário', icone: 'icon icon-users4' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ClientesUsuariosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-users4' },
                  },
                  {
                    path: 'upd',
                    component: ClientesUsuariosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-users4' }
                  }
                ]
              }
            ]
          },
          {
            path: 'add',
            component: ClientesFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-university' }
          },
          {
            path: ':id_cliente',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ClientesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
              },
              {
                path: 'upd',
                component: ClientesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-university' }
              },
            ]
          },
        ]
      },
      {
        path: 'exportadores',
        canActivate: [LoginGuard],
        data: { title: 'Exportadores', breadcrumb: 'Exportadores', icone: 'fa fa-university' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: ExportadoresComponent,
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
          },
          {
            path: 'add',
            component: ExportadoresFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-university' }
          },
          {
            path: ':id_exportador',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ExportadoresFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
              },
              {
                path: 'upd',
                component: ExportadoresFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-university' }
              },
            ]
          },
        ]
      },
      {
        path: 'terminais',
        canActivate: [LoginGuard],
        data: { title: 'Terminais', breadcrumb: 'Terminais', icone: 'fa fa-university' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: TerminaisComponent,
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
          },
          {
            path: 'add',
            component: TerminaisFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-university' }
          },
          {
            path: ':id_terminal',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: TerminaisFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
              },
              {
                path: 'upd',
                component: TerminaisFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-university' }
              },
            ]
          },
        ]
      },
      {
        path: 'armadores',
        canActivate: [LoginGuard],
        data: { title: 'Armadores', breadcrumb: 'Armadores', icone: 'fa fa-university' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: ArmadoresComponent,
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
          },
          {
            path: 'add',
            component: ArmadoresFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-university' }
          },
          {
            path: ':id_armador',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ArmadoresFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-university' },
              },
              {
                path: 'upd',
                component: ArmadoresFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-university' }
              },
            ]
          },
        ]
      },
      {
        path: 'unidades',
        canActivate: [LoginGuard],
        data: { title: 'Unidades', breadcrumb: 'Unidades', icone: 'icon-city' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: UnidadesComponent,
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-city' },
          },
          {
            path: 'add',
            component: UnidadesFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-city' }
          },
          {
            path: ':id_unidade',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-city' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: UnidadesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-city' },
              },
              {
                path: 'upd',
                component: UnidadesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-city' }
              },
            ]
          },
        ]
      },
      {
        path: 'locais',
        canActivate: [LoginGuard],
        data: { title: 'Locais', breadcrumb: 'Locais', icone: 'icon-location4' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: LocaisComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-location4' },
          },
          {
            path: 'add',
            component: LocaisFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-location4' }
          },
          {
            path: ':id_local',
            canActivate: [LoginGuard],
            data: { title: 'Local', breadcrumb: 'Local', icone: 'icon-location4' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LocaisFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Local', breadcrumb: 'Local', icone: 'icon-location4' },
              },
              {
                path: 'upd',
                component: LocaisFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-location4' }
              }
            ]
          }
        ]
      },
      {
        path: 'transportes',
        canActivate: [LoginGuard],
        data: { title: 'Transportes', breadcrumb: 'Transportes', icone: 'icon-road-sign' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: TransportesComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-road-sign' },
          },
          {
            path: 'add',
            component: TransportesFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-road-sign' }
          },
          {
            path: 'viagens',
            canActivate: [LoginGuard],
            data: { title: 'Viagens', breadcrumb: 'Viagens', icone: 'fa fa-ship' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: TransportesViagensComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-ship' },
              },
              {
                path: 'add',
                component: TransportesViagensFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-ship' }
              },
              {
                path: ':id_viagem',
                canActivate: [LoginGuard],
                data: { title: 'Viagens', breadcrumb: 'Viagens', icone: 'fa fa-ship' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: TransportesViagensFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Viagens', breadcrumb: 'Viagens', icone: 'fa fa-ship' },
                  },
                  {
                    path: 'upd',
                    component: TransportesViagensFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-ship' }
                  }
                ]
              }
            ]
          },
          {
            path: ':id_transporte',
            canActivate: [LoginGuard],
            data: { title: 'Transporte', breadcrumb: 'Transporte', icone: 'icon-road-sign' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: TransportesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Transporte', breadcrumb: 'Transporte', icone: 'icon-road-sign' },
              },
              {
                path: 'upd',
                component: TransportesFormComponent,
                canActivate: [LoginGuard], data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-road-sign' }
              },
              {
                path: 'viagens/add',
                component: TransportesViagensFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar Viagem', breadcrumb: 'Adicionar Viagem', icone: 'fa fa-ship' }
              },
              {
                path: 'viagens/:id_viagem/upd',
                component: TransportesViagensFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar Viagem', breadcrumb: 'Editar Viagem', icone: 'fa fa-ship' }
              }
            ]
          }
        ]
      },
      {
        path: 'moedas',
        canActivate: [LoginGuard],
        data: { title: 'Moedas', breadcrumb: 'Moedas', icone: 'icon icon-coins' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: MoedasComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-coins' },
          },
          {
            path: 'add',
            component: MoedasFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon icon-coins' }
          },
          {
            path: ':id_moeda',
            canActivate: [LoginGuard],
            data: { title: 'Moeda', breadcrumb: 'Moeda', icone: 'icon icon-coins' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MoedasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-coins' },
              },
              {
                path: 'upd',
                component: MoedasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon icon-coins' }
              }
            ]
          }
        ]
      },
      {
        path: 'laudos-cd',
        canActivate: [LoginGuard],
        data: { title: 'Laudos CD', breadcrumb: 'Laudos CD', icone: 'icon icon-file-list' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: LaudosCDComponent,
            canActivate: [LoginGuard],
            data: { title: 'Laudos CD', breadcrumb: 'Laudos CD', icone: 'icon icon-file-list' }
          },
          {
            path: 'add',
            component: LaudosCDFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar Laudo CD', breadcrumb: 'Adicionar Laudo CD', icone: 'icon icon-file-list' }
          },
          {
            path: 'stakeholders',
            canActivate: [LoginGuard],
            data: { title: 'Stakeholders', breadcrumb: 'Stakeholders', icone: 'icon icon-users4' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: StakeholdersComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-users4' },
              },
              {
                path: 'add',
                component: StakeholdersFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar Stakeholder', breadcrumb: 'Adicionar', icone: 'icon icon-users4' }
              },
              {
                path: ':id_stakeholder',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar Stakeholder', breadcrumb: 'Stakeholder', icone: 'icon icon-users4' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: StakeholdersFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-users4' },
                  },
                  {
                    path: 'upd',
                    component: StakeholdersFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-users4' }
                  }
                ]
              }
            ]
          },
          {
            path: 'responsaveis-tecnicos',
            canActivate: [LoginGuard],
            data: { title: 'Responsáveis Técnicos', breadcrumb: 'Responsáveis Técnicos', icone: 'icon icon-users4' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ResponsaveisTecnicosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-users4' },
              },
              {
                path: 'add',
                component: ResponsaveisTecnicosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar Responsável Técnico', breadcrumb: 'Adicionar', icone: 'icon icon-users4' }
              },
              {
                path: ':id_responsavel_tecnico',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar Responsável Técnico', breadcrumb: 'Responsável Técnico', icone: 'icon icon-users4' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ResponsaveisTecnicosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-users4' },
                  },
                  {
                    path: 'upd',
                    component: ResponsaveisTecnicosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-users4' }
                  }
                ]
              }
            ]
          },
          {
            path: 'observacoes',
            canActivate: [LoginGuard],
            data: { title: 'Observações', breadcrumb: 'Observações', icone: 'icon icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ObservacoesLaudosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-file-list' },
              },
              {
                path: 'add',
                component: ObservacoesLaudosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar Observação', breadcrumb: 'Adicionar', icone: 'icon icon-file-list' }
              },
              {
                path: ':id_observacao',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar Observação', breadcrumb: 'Observação', icone: 'icon icon-file-list' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ObservacoesLaudosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-file-list' },
                  },
                  {
                    path: 'upd',
                    component: ObservacoesLaudosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-file-list' }
                  }
                ]
              }
            ]
          },
          {
            path: 'observacoes-fixas',
            canActivate: [LoginGuard],
            data: { title: 'Observações Fixas', breadcrumb: 'Observações Fixas', icone: 'icon icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ObservacoesFixasComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-file-list' },
              },
              {
                path: 'add',
                component: ObservacoesFixasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar Observação Fixa', breadcrumb: 'Adicionar', icone: 'icon icon-file-list' }
              },
              {
                path: ':id_observacao_fixa',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar Observação Fixa', breadcrumb: 'Observação Fixa', icone: 'icon icon-file-list' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ObservacoesFixasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-file-list' },
                  },
                  {
                    path: 'upd',
                    component: ObservacoesFixasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-file-list' }
                  }
                ]
              }
            ]
          },
          {
            path: 'transportadoras',
            canActivate: [LoginGuard],
            data: { title: 'Transportadoras', breadcrumb: 'Transportadoras', icone: 'icon icon-road-sign' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: TransportadorasComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-road-sign' },
              },
              {
                path: 'add',
                component: TransportadorasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon icon-road-sign' }
              },
              {
                path: ':id_transportadora',
                canActivate: [LoginGuard],
                data: { title: 'Transportadora', breadcrumb: 'Transportadora', icone: 'icon icon-road-sign' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: TransportadorasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-road-sign' },
                  },
                  {
                    path: 'upd',
                    component: TransportadorasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-road-sign' }
                  }
                ]
              }
            ]
          },
          {
            path: 'coloracao',
            canActivate: [LoginGuard],
            data: { title: 'Coloração', breadcrumb: 'Coloração', icone: 'icon icon-road-sign' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ColoracaoComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-road-sign' },
              },
              {
                path: 'add',
                component: ColoracaoFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon icon-road-sign' }
              },
              {
                path: ':id_coloracao',
                canActivate: [LoginGuard],
                data: { title: 'Coloração', breadcrumb: 'Coloração', icone: 'icon icon-road-sign' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ColoracaoFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-road-sign' },
                  },
                  {
                    path: 'upd',
                    component: ColoracaoFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-road-sign' }
                  }
                ]
              }
            ]
          },
          {
            path: 'tipo-transporte',
            canActivate: [LoginGuard],
            data: { title: 'Tipo Transporte', breadcrumb: 'Tipo Transporte', icone: 'icon icon-road-sign' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: TipoTransporteComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-road-sign' },
              },
              {
                path: 'add',
                component: TipoTransporteFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon icon-road-sign' }
              },
              {
                path: ':id_tipo_transporte',
                canActivate: [LoginGuard],
                data: { title: 'Tipo Transporte', breadcrumb: 'Tipo Transporte', icone: 'icon icon-road-sign' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: TipoTransporteFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-road-sign' },
                  },
                  {
                    path: 'upd',
                    component: TipoTransporteFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-road-sign' }
                  }
                ]
              }
            ]
          },
          {
            path: 'tipo-unidade',
            canActivate: [LoginGuard],
            data: { title: 'Tipo Unidade', breadcrumb: 'Tipo Unidade', icone: 'icon icon-road-sign' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: TipoUnidadeComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-road-sign' },
              },
              {
                path: 'add',
                component: TipoUnidadeFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon icon-road-sign' }
              },
              {
                path: ':id_tipo_unidade',
                canActivate: [LoginGuard],
                data: { title: 'Tipo Unidade', breadcrumb: 'Tipo Unidade', icone: 'icon icon-road-sign' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: TipoUnidadeFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-road-sign' },
                  },
                  {
                    path: 'upd',
                    component: TipoUnidadeFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-road-sign' }
                  }
                ]
              }
            ]
          },
          {
            path: 'labels-fotos',
            canActivate: [LoginGuard],
            data: { title: 'Labels Fotos', breadcrumb: 'Labels Fotos', icone: 'icon icon-road-sign' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LabelFotosLaudoscdComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-road-sign' },
              },
              {
                path: 'add',
                component: LabelFotosLaudoscdFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon icon-road-sign' }
              },
              {
                path: ':id_label_foto',
                canActivate: [LoginGuard],
                data: { title: 'Label Foto', breadcrumb: 'Label Foto', icone: 'icon icon-road-sign' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: LabelFotosLaudoscdFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-road-sign' },
                  },
                  {
                    path: 'upd',
                    component: LabelFotosLaudoscdFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-road-sign' }
                  }
                ]
              }
            ]
          },
          {
            path: ':id_laudo_cd',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar Laudo CD', breadcrumb: 'Laudo CD', icone: 'icon icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LaudosCDFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-file-list' },
              },
              {
                path: 'upd',
                component: LaudosCDFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-file-list' }
              },
              {
                path: 'pdf',
                component: PdfLaudoCDComponent,
                canActivate: [LoginGuard],
                data: { title: 'Gerar PDF', breadcrumb: 'Gerar PDF', icone: 'icon icon-file-pdf' }
              }
            ]
          }
        ]
      },
      {
        path: 'laudos-tecnicos',
        canActivate: [LoginGuard],
        data: { title: 'Laudos Técnicos', breadcrumb: 'Laudos Técnicos', icone: 'icon icon-file-list' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: LaudosTecnicosComponent,
            canActivate: [LoginGuard],
            data: { title: 'Laudos Técnicos', breadcrumb: 'Laudos Técnicos', icone: 'icon icon-file-list' }
          },
          {
            path: 'add',
            component: LaudosTecnicosFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar Laudo Técnico', breadcrumb: 'Adicionar Laudo Técnico', icone: 'icon icon-file-list' }
          },
          {
            path: 'stakeholders',
            canActivate: [LoginGuard],
            data: { title: 'Stakeholders', breadcrumb: 'Stakeholders', icone: 'icon icon-users4' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: StakeholdersTecnicosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-users4' },
              },
              {
                path: 'add',
                component: StakeholdersTecnicosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar Stakeholder', breadcrumb: 'Adicionar', icone: 'icon icon-users4' }
              },
              {
                path: ':id_stakeholder',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar Stakeholder', breadcrumb: 'Stakeholder', icone: 'icon icon-users4' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: StakeholdersTecnicosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-users4' },
                  },
                  {
                    path: 'upd',
                    component: StakeholdersTecnicosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-users4' }
                  }
                ]
              }
            ]
          },


          {
            path: 'labels-fotos',
            canActivate: [LoginGuard],
            data: { title: 'Labels Fotos', breadcrumb: 'Labels Fotos', icone: 'icon icon-road-sign' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LabelFotosLaudosTecnicosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-road-sign' },
              },
              {
                path: 'add',
                component: LabelFotosLaudosTecnicosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon icon-road-sign' }
              },
              {
                path: ':id_label_foto',
                canActivate: [LoginGuard],
                data: { title: 'Label Foto', breadcrumb: 'Label Foto', icone: 'icon icon-road-sign' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: LabelFotosLaudosTecnicosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-road-sign' },
                  },
                  {
                    path: 'upd',
                    component: LabelFotosLaudosTecnicosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-road-sign' }
                  }
                ]
              }
            ]
          },
          {
            path: ':id_laudo_tecnico',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar Laudo Técnico', breadcrumb: 'Laudo Técnico', icone: 'icon icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LaudosTecnicosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon icon-file-list' },
              },
              {
                path: 'upd',
                component: LaudosTecnicosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon icon-file-list' }
              },
              {
                path: 'pdf',
                component: PdfLaudoTecnicoComponent,
                canActivate: [LoginGuard],
                data: { title: 'Gerar PDF', breadcrumb: 'Gerar PDF', icone: 'icon icon-file-pdf' }
              }
            ]
          }
        ]
      },
      {
        path: 'mercadorias',
        canActivate: [LoginGuard],
        data: { title: 'Mercadorias', breadcrumb: 'Mercadorias', icone: 'fa fa-shopping-cart' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: MercadoriasComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-shopping-cart' },
          },
          {
            path: 'add',
            component: MercadoriasFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-shopping-cart' }
          },
          {
            path: 'defeitos',
            canActivate: [LoginGuard],
            data: { title: 'Defeitos', breadcrumb: 'Defeitos', icone: 'fa fa-shopping-cart' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoriasDefeitosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-shopping-cart' },
              },
              {
                path: 'add',
                component: MercadoriasDefeitosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-shopping-cart' }
              },

              {
                path: ':id_defeito',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: MercadoriasDefeitosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                  },
                  {
                    path: 'upd',
                    component: MercadoriasDefeitosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-shopping-cart' }
                  }
                ]
              }
            ]
          },
          {
            path: 'variedades',
            canActivate: [LoginGuard],
            data: { title: 'Variedades', breadcrumb: 'Variedades', icone: 'fa fa-shopping-cart' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoriasVariedadesComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-shopping-cart' },
              },
              {
                path: 'add',
                component: MercadoriasVariedadesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-shopping-cart' }
              },
              {
                path: ':id_variedade',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: MercadoriasVariedadesFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                  },
                  {
                    path: 'upd',
                    component: MercadoriasVariedadesFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-shopping-cart' }
                  }
                ]
              }
            ]
          },
          {
            path: 'classificacao',
            canActivate: [LoginGuard],
            data: { title: 'Classificação', breadcrumb: 'Classificação', icone: 'fa fa-shopping-cart' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoriasClassificacaoComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-shopping-cart' },
              },
              {
                path: 'add',
                component: MercadoriasClassificacaoFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-shopping-cart' }
              },
              {
                path: ':id_classificacao',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: MercadoriasClassificacaoFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
                  },
                  {
                    path: 'upd',
                    component: MercadoriasClassificacaoFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-shopping-cart' }
                  }
                ]
              }
            ]
          },
          {
            path: 'embalagens',
            canActivate: [LoginGuard],
            data: { title: 'Embalagens', breadcrumb: 'Embalagens', icone: 'fa fa-cube' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoriasEmbalagensComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-cube' },
              },
              {
                path: 'add',
                component: MercadoriasEmbalagensFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-cube' }
              },
              {
                path: ':id_embalagem',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cube' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: MercadoriasEmbalagensFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cube' },
                  },
                  {
                    path: 'upd',
                    component: MercadoriasEmbalagensFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-cube' }
                  }
                ]
              }
            ]
          },
          {
            path: 'categorias',
            canActivate: [LoginGuard],
            data: { title: 'Categorias', breadcrumb: 'Categorias', icone: 'fa fa-cube' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoriasCategoriasComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-cube' },
              },
              {
                path: 'add',
                component: MercadoriasCategoriasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-cube' }
              },
              {
                path: ':id_categoria',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cube' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: MercadoriasCategoriasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cube' },
                  },
                  {
                    path: 'upd',
                    component: MercadoriasCategoriasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-cube' }
                  }
                ]
              }
            ]
          },
          {
            path: 'coloracao',
            canActivate: [LoginGuard],
            data: { title: 'Coloracao', breadcrumb: 'Coloracao', icone: 'fa fa-cube' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoriasColoracaoComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-cube' },
              },
              {
                path: 'add',
                component: MercadoriasColoracaoFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-cube' }
              },
              {
                path: ':id_coloracao',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cube' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: MercadoriasColoracaoFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cube' },
                  },
                  {
                    path: 'upd',
                    component: MercadoriasColoracaoFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-cube' }
                  }
                ]
              }
            ]
          },
          {
            path: ':id_mercadoria',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: MercadoriasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-shopping-cart' },
              },
              {
                path: 'upd',
                component: MercadoriasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-shopping-cart' }
              }
            ]
          }
        ]
      },
      {
        path: 'containers',
        canActivate: [LoginGuard],
        data: { title: 'Containers', breadcrumb: 'Containers', icone: 'fa fa-cubes' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: ContainersComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-cubes' },
          },
          {
            path: 'add',
            component: ContainersFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-cubes' }
          },
          {
            path: ':id_container',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cubes' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ContainersFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cubes' },
              },
              {
                path: 'upd',
                component: ContainersFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-cubes' }
              }
            ]
          }
        ]
      },
      {
        path: 'followup',
        canActivate: [LoginGuard],
        data: { title: 'Follow Up', breadcrumb: 'Follow Up', icone: 'fa fa-cubes' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: FollowUpComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-cubes' },
          },
          {
            path: 'add',
            component: FollowUpFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-cubes' }
          },
          {
            path: ':id_followup',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cubes' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: FollowUpFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-cubes' },
              },
              {
                path: 'upd',
                component: FollowUpFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-cubes' }
              }
            ]
          }
        ]
      },
      {
        path: 'veiculos',
        canActivate: [LoginGuard],
        data: { title: 'Veículos', breadcrumb: 'Veículos', icone: 'fa fa-car' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: VeiculosComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-car' },
          },
          {
            path: 'add',
            component: VeiculosFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-car' }
          },
          {
            path: ':id_veiculo',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-car' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: VeiculosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-car' },
              },
              {
                path: 'upd',
                component: VeiculosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-car' }
              },
              {
                path: 'arquivos',
                component: VeiculosArquivosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Arquivos', breadcrumb: 'Arquivos', icone: 'fa fa-car' }
              }
            ]
          }
        ]
      },
      {
        path: 'veiculos-corridas',
        canActivate: [LoginGuard],
        data: { title: 'Veículos Corrida', breadcrumb: 'Veículos Corrida', icone: 'fa fa-car' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: VeiculosCorridaComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'fa fa-car' },
          },
          {
            path: 'add',
            component: VeiculosCorridaFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-car' }
          },
          {
            path: ':id_corrida',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-car' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: VeiculosCorridaFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-car' },
              },
              {
                path: 'upd',
                component: VeiculosCorridaFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-car' }
              }
            ]
          }
        ]
      },
      {
        path: 'equipamentos',
        canActivate: [LoginGuard],
        data: { title: 'Equipamentos', breadcrumb: 'Equipamentos', icone: 'icon-tools' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: EquipamentosComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-tools' },
          },
          {
            path: 'add',
            component: EquipamentosFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-tools' }
          },
          {
            path: ':id_equipamento',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-tools' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: EquipamentosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-tools' },
              },
              {
                path: 'upd',
                component: EquipamentosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-tools' }
              }
            ]
          }
        ]
      },
      {
        path: 'paises',
        canActivate: [LoginGuard],
        data: { title: 'Países', breadcrumb: 'Países', icone: 'fa fa-globe' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: PaisesComponent,
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-globe' },
          },
          {
            path: 'add',
            component: PaisesFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-globe' }
          },
          {
            path: ':id_pais',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-globe' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: PaisesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-globe' },
              },
              {
                path: 'upd',
                component: PaisesFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-globe' }
              }
            ]
          }
        ]
      },
      {
        path: 'fichas',
        canActivate: [LoginGuard],
        data: { title: 'Fichas', breadcrumb: 'Fichas', icone: 'icon-file-list' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: FichasComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-file-list' },
          },
          {
            path: 'add',
            component: FichasFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-file-list' }
          },
          {
            path: 'previstas',
            component: FichasComponent,
            canActivate: [LoginGuard],
            data: { title: 'Previstas', breadcrumb: 'Previstas', icone: 'icon-file-list' }
          },
          {
            path: 'observacoes',
            canActivate: [LoginGuard],
            data: { title: 'Observações', breadcrumb: 'Observações', icone: 'icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ObservacoesFichasComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-file-list' },
              },
              {
                path: 'add',
                component: ObservacoesFichasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-file-list' }
              },
              {
                path: ':id_observacao',
                canActivate: [LoginGuard],
                data: { title: 'Observação', breadcrumb: 'Observação', icone: 'icon-file-list' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ObservacoesFichasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Observação', breadcrumb: 'Observação', icone: 'icon-file-list' },
                  },
                  {
                    path: 'upd',
                    component: ObservacoesFichasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-file-list' }
                  }
                ]
              }
            ]
          },
          {
            path: 'observacoes-fixas',
            canActivate: [LoginGuard],
            data: { title: 'Observações Fixas', breadcrumb: 'Observações Fixas', icone: 'icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: FichasObservacoesFixasComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-file-list' },
              },
              {
                path: 'add',
                component: FichasObservacoesFixasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-file-list' }
              },
              {
                path: ':id_observacao_fixa',
                canActivate: [LoginGuard],
                data: { title: 'Observação Fixa', breadcrumb: 'Observação Fixa', icone: 'icon-file-list' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: FichasObservacoesFixasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Observação Fixa', breadcrumb: 'Observação Fixa', icone: 'icon-file-list' },
                  },
                  {
                    path: 'upd',
                    component: FichasObservacoesFixasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-file-list' }
                  }
                ]
              }
            ]
          },
          {
            path: 'conclusoes',
            canActivate: [LoginGuard],
            data: { title: 'Conclusões', breadcrumb: 'Conclusões', icone: 'icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ConclusoesFichasComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-file-list' },
              },
              {
                path: 'add',
                component: ConclusoesFichasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-file-list' }
              },
              {
                path: ':id_conclusao',
                canActivate: [LoginGuard],
                data: { title: 'Conclusão', breadcrumb: 'Conclusão', icone: 'icon-file-list' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ConclusoesFichasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Conclusão', breadcrumb: 'Conclusão', icone: 'icon-file-list' },
                  },
                  {
                    path: 'upd',
                    component: ConclusoesFichasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-file-list' }
                  }
                ]
              }
            ]
          },
          {
            path: 'protestos',
            canActivate: [LoginGuard],
            data: { title: 'Protestos', breadcrumb: 'Protestos', icone: 'icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: ProtestosFichasComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-file-list' },
              },
              {
                path: 'add',
                component: ProtestosFichasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-file-list' }
              },
              {
                path: ':id_protesto',
                canActivate: [LoginGuard],
                data: { title: 'Protestos', breadcrumb: 'Protestos', icone: 'icon-file-list' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: ProtestosFichasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Protestos', breadcrumb: 'Protestos', icone: 'icon-file-list' },
                  },
                  {
                    path: 'upd',
                    component: ProtestosFichasFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-file-list' }
                  }
                ]
              }
            ]
          },
          {
            path: 'laudos-pdf',
            canActivate: [LoginGuard],
            data: { title: 'Laudos PDF', breadcrumb: 'Laudos PDF', icone: 'icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LaudosPdfComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-file-list' },
              },
              {
                path: 'add',
                component: LaudosPdfFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-file-list' }
              },
              {
                path: ':id_laudo',
                canActivate: [LoginGuard],
                data: { title: 'Protestos', breadcrumb: 'Protestos', icone: 'icon-file-list' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: LaudosPdfFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Protestos', breadcrumb: 'Protestos', icone: 'icon-file-list' },
                  },
                  {
                    path: 'upd',
                    component: LaudosPdfFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-file-list' }
                  }
                ]
              }
            ]
          },
          {
            path: ':id_ficha',
            canActivate: [LoginGuard],
            data: { title: 'Ficha', breadcrumb: 'Ficha', icone: 'icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: FichasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Local', breadcrumb: 'Local', icone: 'icon-file-list' },
              },
              {
                path: 'upd',
                component: FichasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-file-list' }
              },
              {
                path: 'visualizar',
                component: VisualizarFichaComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-file-pdf' }
              },
              {
                path: 'pdf',
                component: PdfFichaComponent,
                canActivate: [LoginGuard],
                data: { title: 'Ficha PDF', breadcrumb: 'Ficha PDF', icone: 'icon-stack3' }
              }
            ]
          }
        ]
      },
      {
        path: 'financeiro',
        canActivate: [LoginGuard],
        data: { title: 'Financeiro', breadcrumb: 'Finenceiro', icone: 'icon icon-coins' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: FinanceiroComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-coins' },
          },
          {
            path: 'controle-financeiro',
            component: ControleFinanceiroComponent,
            canActivate: [LoginGuard],
            data: { title: 'Controle Financeiro', breadcrumb: 'Controle Financeiro', icone: 'icon icon-coins' }
          },
          {
            path: 'relatorio-completo',
            component: RelatorioCompletoComponent,
            canActivate: [LoginGuard],
            data: { title: 'Relatório Completo', breadcrumb: 'Relatório Completo', icone: 'icon icon-calculator' }
          },
          {
            path: 'dashboard',
            component: DashboardFinanceiroComponent,
            canActivate: [LoginGuard],
            data: { title: 'Dashboard Financeiro', breadcrumb: 'Dashboard Financeiro', icone: 'icon icon-stats-dots' }
          },
          {
            path: 'clientes',
            canActivate: [LoginGuard],
            data: { title: 'Financeiro Clientes', breadcrumb: 'Financeiro Clientes', icone: 'icon icon-coins' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: FinanceiroClientesComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem' }
              },
              {
                path: ':id_cliente/preliminares',
                component: FinanceiroPreliminaresClienteComponent,
                canActivate: [LoginGuard],
                data: { title: 'Preliminares', breadcrumb: 'Preliminares' }
              },
              {
                path: ':id_cliente/laudos-pdf',
                component: FinanceiroLaudosPdfClienteComponent,
                canActivate: [LoginGuard],
                data: { title: 'Laudos PDF', breadcrumb: 'Laudos PDF' }
              },
              {
                path: ':id_cliente/laudos-cd',
                component: FinanceiroLaudosCdClienteComponent,
                canActivate: [LoginGuard],
                data: { title: 'Laudos CD', breadcrumb: 'Laudos CD' }
              },
              {
                path: ':id_cliente/laudos-tecnicos',
                component: FinanceiroLaudosTecnicosClienteComponent,
                canActivate: [LoginGuard],
                data: { title: 'Laudos Técnicos', breadcrumb: 'Laudos Técnicos' }
              },
              {
                path: ':id_cliente/certificados-nacionais',
                component: FinanceiroCertificadosNacionaisClienteComponent,
                canActivate: [LoginGuard],
                data: { title: 'Certificados Nacionais', breadcrumb: 'Certificados Nacionais' }
              }
            ]
          },
          {
            path: 'bancos',
            canActivate: [LoginGuard],
            data: { title: 'Bancos', breadcrumb: 'Bancos', icone: 'fa fa-globe' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: BancosComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-globe' },
              },
              {
                path: 'add',
                component: BancosFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'fa fa-globe' }
              },
              {
                path: ':id_banco',
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-globe' },
                children: [
                  {
                    path: '',
                    pathMatch: 'full',
                    component: BancosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'fa fa-globe' },
                  },
                  {
                    path: 'upd',
                    component: BancosFormComponent,
                    canActivate: [LoginGuard],
                    data: { title: 'Editar', breadcrumb: 'Editar', icone: 'fa fa-globe' }
                  }
                ]
              }
            ]
          },
          {
            path: 'laudos-pdf',
            canActivate: [LoginGuard],
            data: { title: 'Laudos PDF', breadcrumb: 'Laudos PDF', icone: 'icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LaudosPdfFinanceiroComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-file-list' },
              }
            ]
          },
          {
            path: 'laudos-cd',
            canActivate: [LoginGuard],
            data: { title: 'Laudos CD', breadcrumb: 'Laudos CD', icone: 'icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LaudosCDFinanceiroComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-file-list' },
              }
            ]
          },
          {
            path: 'laudos-tecnicos',
            canActivate: [LoginGuard],
            data: { title: 'Laudos Técnicos', breadcrumb: 'Laudos Técnicos', icone: 'icon-file-list' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: LaudosTecnicosFinanceiroComponent,
                canActivate: [LoginGuard],
                data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon-file-list' },
              }
            ]
          }
        ]
      },
      {
        path: 'faturas',
        canActivate: [LoginGuard],
        data: { title: 'Faturas', breadcrumb: 'Faturas', icone: 'icon icon-coins' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: FaturasComponent,
            canActivate: [LoginGuard],
            data: { title: 'Listagem', breadcrumb: 'Listagem', icone: 'icon icon-coins' },
          },
          {
            path: 'add',
            component: FaturasFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-city' }
          },
          {
            path: ':id_fatura',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-city' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: VisualizarFaturaComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-city' },
              },
              {
                path: 'pdf',
                component: PdfFaturaComponent,
                canActivate: [LoginGuard],
                data: { title: 'Fatura PDF', breadcrumb: 'Fatura PDF', icone: 'icon-stack3' }
              },
              {
                path: 'upd',
                component: FaturasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-city' }
              }
            ]
          },
        ]
      },
      {
        path: 'unidades-medidas',
        canActivate: [LoginGuard],
        data: { title: 'Unidades de Medidas', breadcrumb: 'Unidades de Medidas', icone: 'icon-city' },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: UnidadesMedidasComponent,
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-city' },
          },
          {
            path: 'add',
            component: UnidadesMedidasFormComponent,
            canActivate: [LoginGuard],
            data: { title: 'Adicionar', breadcrumb: 'Adicionar', icone: 'icon-city' }
          },
          {
            path: ':id_unidade',
            canActivate: [LoginGuard],
            data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-city' },
            children: [
              {
                path: '',
                pathMatch: 'full',
                component: UnidadesMedidasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Visualizar', breadcrumb: 'Visualizar', icone: 'icon-city' },
              },
              {
                path: 'upd',
                component: UnidadesMedidasFormComponent,
                canActivate: [LoginGuard],
                data: { title: 'Editar', breadcrumb: 'Editar', icone: 'icon-city' }
              },
            ]
          },
        ]
      },
      {
        path: 'area-cliente/minhas-fichas',
        component: MinhasFichasComponent,
        canActivate: [LoginGuard],
        data: { title: 'Minhas Fichas', breadcrumb: 'Minhas Fichas', icone: 'icon-stack3' }
      },
      {
        path: 'area-cliente/ficha/:id_ficha',
        component: FichaClienteComponent,
        canActivate: [LoginGuard],
        data: { title: 'Ficha', breadcrumb: 'Ficha', icone: 'icon-stack3' }
      },
      {
        path: 'area-cliente/ficha/:id_ficha/pdf',
        component: PdfFichaClienteComponent,
        canActivate: [LoginGuard],
        data: { title: 'Ficha PDF', breadcrumb: 'Ficha PDF', icone: 'icon-stack3' }
      },
      {
        path: 'area-cliente/meus-laudos-pdf',
        component: MeusLaudosPdfComponent,
        canActivate: [LoginGuard],
        data: { title: 'Laudos PDF', breadcrumb: 'Laudos PDF', icone: 'icon-stack3' }
      },
      {
        path: 'area-cliente/laudo-pdf/:id_laudo',
        component: MeusLaudosPdfFormComponent,
        canActivate: [LoginGuard],
        data: { title: 'Laudo PDF', breadcrumb: 'Laudo PDF', icone: 'icon-stack3' }
      },
      {
        path: 'area-cliente/meus-laudos-cd',
        component: MeusLaudosCDComponent,
        canActivate: [LoginGuard],
        data: { title: 'Laudos CD', breadcrumb: 'Laudos CD', icone: 'icon-stack3' }
      },
      {
        path: 'area-cliente/laudo-cd/:id_laudo',
        component: MeusLaudosCDFormComponent,
        canActivate: [LoginGuard],
        data: { title: 'Laudo CD', breadcrumb: 'Laudo CD', icone: 'icon-stack3' }
      },
      {
        path: 'area-cliente/meus-laudos-tecnicos',
        component: MeusLaudosTecnicosComponent,
        canActivate: [LoginGuard],
        data: { title: 'Laudos Técnicos', breadcrumb: 'Laudos Técnicos', icone: 'icon-stack3' }
      },
      {
        path: 'area-cliente/laudo-tecnico/:id_laudo',
        component: MeusLaudosTecnicosFormComponent,
        canActivate: [LoginGuard],
        data: { title: 'Laudo Técnico', breadcrumb: 'Laudo Técnico', icone: 'icon-stack3' }
      },
      {
        path: 'area-cliente/meus-testes-sopro',
        component: MeusTestesSoproComponent,
        canActivate: [LoginGuard],
        data: { title: 'Teste de Álcool', breadcrumb: 'Teste de Álcool', icone: 'fa fa-stethoscope' }
      },
      {
        path: 'area-cliente/meus-testes-sopro/:id_teste/pdf',
        component: PdfMeusTestesSoproComponent,
        canActivate: [LoginGuard],
        data: { title: 'Teste de Álcool PDF', breadcrumb: 'Teste de Álcool PDF', icone: 'fa fa-stethoscope' }
      },
      {
        path: 'area-cliente/teste-sopro/:id_teste/pdf',
        component: PdfMeusTestesSoproComponent,
        canActivate: [LoginGuard],
        data: { title: 'Teste de Álcool PDF', breadcrumb: 'Teste de Álcool PDF', icone: 'fa fa-stethoscope' }
      },
    ]
  }
];




// WEBPACK FOOTER //
// ./src/app/app.routes.ts